<template>
  <div class="layout pad20" id="myComponentDiv">
    <div class="box-titulo">Facturador de FillPos</div>
    <div style="display: none">
      <input class="form-control" v-model="fecha" readonly disabled />
    </div>

    <div>Factura</div>
    <div class="area-facturas-box">
      <div v-if="factura_prefijo != null">
        <div class="area-facturas-h1">{{ factura_prefijo }}-{{ factura_consecutivo }}</div>
        <div class="area-facturas-h2">{{ factura_hasp }}</div>
      </div>
      <div v-else>
        <div>
          <div class="area-facturas-hn">[BORRADOR]</div>
          <div class="area-facturas-h2">&nbsp;</div>
        </div>
      </div>
    </div>

    <!-- CLIENTE -->
    <div>
      <div class="label">Cliente</div>
      <div>
        <Select2 v-model="cliente" :options="lista_clientes" @select="selectCliente($event)" />
      </div>
    </div>

    <!-- TIPO VENTA / MÉTODO PAGO -->
    <div class="row">
      <div class="col-lg-6">
        <div>Tipo de venta</div>
        <div>
          <select class="form-control" v-model="tipo_venta">
            <option v-for="item in lista_tipo_venta" :key="item._id" :value="item._id">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-lg-6">
        <div>Método de pago</div>
        <div>
          <select class="form-control" v-model="metodo_pago" :disabled="disabled_metodo_pago">
            <option v-for="item in lista_metodo_pago" :key="item._id" :value="item._id">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- USO CFDI / FORMA PAGO -->
    <div class="row">
      <div class="col-lg-6">
        <div>Uso de CFDI</div>
        <div>
          <select class="form-control" v-model="uso_cfdi" :disabled="disabled_uso_cfdi">
            <option v-for="item in lista_uso_cfdi" :key="item._id" :value="item._id">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-lg-6">
        <div>Forma de pago</div>
        <div>
          <select class="form-control" v-model="forma_pago" :disabled="disabled_forma_pago">
            <option v-for="item in lista_forma_pago" :key="item._id" :value="item._id">
              {{ item.codigo }} - {{ item.descripcion }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- PERIODICIDAD -->
    <div v-if="mostrar_periodo">
      <div>Periodicidad</div>
      <div>
        <select class="form-control" v-model="perioricidad">
          <option v-for="item in lista_perioricidad" :key="item._id" :value="item._id">
            {{ item.codigo }} - {{ item.descripcion }}
          </option>
        </select>
      </div>
    </div>

    <!-- PRODUCTOS -->
    <div class="product-selection">
      <div class="label">Seleccionar Producto</div>
      <div class="row">
        <div class="col-lg-12">
          <Select2 ref="productSelect" :key="productSelectKey" v-model="selected_product" :options="lista_productos"
            :settings="{
              placeholder: 'Seleccione un producto',
              allowClear: true,
              width: '100%'
            }" />
        </div>
      </div>

      <table class="table table-products" width="100%">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Descripcion</th>
            <th width="10%">Impuesto</th>
            <th width="10%">Precio Unitario</th>
            <th width="10%">Cantidad</th>
            <th width="10%">Und</th>
            <th width="10%">Subtotal</th>
            <th width="10%">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in selected_products" :key="product.id || index">
            <td>
              {{ product.plu }} | {{ product.descripcion }}
            </td>
            <td>
              <input type="text" class="form-control" v-model="product.descripcion_item" />
            </td>
            <td>
              {{ product.impuesto ? '16% IVA' : 'Sin IVA' }}
            </td>
            <td class="text-right">
              <input :id="`price-${index}`" type="number" class="form-control text-right"
                :class="{ 'input-error': product.invalidPrecio }" v-model="product.temp_precio" min="0.01" step="0.01"
                @keydown.enter.prevent="commitPrice(index)" @keydown.esc.prevent="cancelPrice(index)"
                @blur="commitPrice(index)" @change="commitPrice(index)" placeholder="0.00" inputmode="decimal"
                pattern="[0-9]*[.,]?[0-9]*" readonly />
            </td>
            <td class="text-right">
              <input :id="`qty-${index}`" type="number" class="form-control text-right"
                :class="{ 'input-error': product.invalidCantidad }" v-model.number="product.cantidad" min="1" step="1"
                @input="updateSubtotal(index)" @blur="updateSubtotal(index)" @change="updateSubtotal(index)"
                placeholder="1" />
            </td>
            <td class="text-left">
              {{ product.unidad_codigo || '' }}
            </td>
            <td>
              {{ GLOBAL.FORMATO_MONEY(product.subtotal) }}
            </td>
            <td>
              <button class="btn btn-danger btn-sm" @click="removeProduct(index)">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- RESUMEN DERECHA -->
    <div class="summary-right">
      <table class="summary-table">
        <tbody>
          <tr>
            <td class="area-facturas-label">CANTIDAD:</td>
            <td class="text-right">
              {{ GLOBAL.FORMATO_NUMBER(total_cantidad) }}
            </td>
          </tr>
          <tr>
            <td class="area-facturas-label">SUBTOTAL:</td>
            <td class="text-right">
              {{ GLOBAL.FORMATO_MONEY(total_subtotal) }}
            </td>
          </tr>
          <tr>
            <td class="area-facturas-label">DESCUENTO:</td>
            <td class="text-right">
              {{ GLOBAL.FORMATO_MONEY(total_descuento) }}
            </td>
          </tr>
          <tr style="border-top: 1px solid #777777">
            <td class="area-facturas-label">TOTAL:</td>
            <td class="text-right">
              {{ GLOBAL.FORMATO_MONEY(total_facturar) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ESTADOS / BOTONES -->
    <div>
      <div class="text-center" v-if="mensaje_guardando">
        <img src="dist/img/guardando.gif" style="width: 30px" />
        <div>Procesando... Por favor espere.</div>
      </div>

      <div class="text-center" v-if="mensaje_enviando">
        <img src="dist/img/enviando.gif" style="width: 30px" />
        <div>Estamos enviando la factura.</div>
      </div>

      <div class="text-center" v-if="mensaje_consultando">
        <img src="dist/img/enviando.gif" style="width: 30px" />
        <div>Estamos consultando el estado en SAT...</div>
      </div>

      <div class="text-center">{{ despacho_mensaje }}</div>

      <div class="text-center">
        <div v-if="proceso_finalizado">
          <button class="btn bg-green" style="width: 200px" @click="nuevaFactura">
            <i class="fa-solid fa-envelope-circle-check"></i><br />NUEVO
          </button>
        </div>
        <div class="btn-group" v-else>
          <button class="btn btn-primary" style="width: 250px" @click="generarFactura"
            :disabled="boton_guardar_desabilitado">
            <i class="fa-solid fa-file-invoice"></i><br />GENERAR
          </button>
        </div>
      </div>
    </div>

    <div v-if="!permiso_lista">
      {{ person?.nombre }}, {{ GLOBAL.MENSAJE.SIN_AUTORIZACION }}
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import FacturadorService from "../Facturador/FacturadorService";
import ClienteService from "../../service/ClienteService";
import Select2 from "vue3-select2-component";
import axios from "axios";

export default {
  components: { Select2 },

  data() {
    return {
      GLOBAL,
      fecha: null,
      fecha_inicio: null,
      fecha_final: null,

      facturadorService: null,
      clienteService: null,

      lista_clientes: [],
      cliente: null,
      clientesById: {},
      tercero_nit: "",

      lista_metodo_pago: [],
      metodo_pago: null,

      lista_forma_pago: [],
      forma_pago: null,

      lista_uso_cfdi: [],
      uso_cfdi: null,

      lista_tipo_venta: [],
      tipo_venta: null,

      lista_perioricidad: [],
      perioricidad: null,
      observaciones: "",

      despacho_loading: false,
      despacho_mensaje: null,

      boton_guardar_desabilitado: false,
      boton_enviar_desabilitado: true,
      boton_consultar_desabilitado: true,

      mensaje_guardando: false,
      mensaje_enviando: false,
      mensaje_consultando: false,

      total_facturar: 0,
      total_subtotal: 0,
      total_descuento: 0,
      total_cantidad: 0,

      factura_prefijo: null,
      factura_consecutivo: null,
      factura_uniqueid: null,
      factura_hasp: null,
      factura_enviada: false,
      factura_sello: null,
      proceso_finalizado: false,

      mostrar_periodo: false,
      zona_horaria: 0,
      disabled_uso_cfdi: false,
      disabled_metodo_pago: false,
      disabled_forma_pago: false,

      permiso_lista: false,
      person: null,
      loading: false,

      lista_productos: [],
      selected_product: null,
      productSelectKey: 0,
      selected_products: []
    };
  },

  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY) || "null");

    this.permiso_lista = !!this.person?.funciones?.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.facturadorService = new FacturadorService();
    this.clienteService = new ClienteService();

    this.fecha = GLOBAL.NOW_ISO();
    this.fecha_inicio = GLOBAL.NOW().split(" ")[0] + " 00:00";
    this.fecha_final = GLOBAL.NOW().split(" ")[0] + " 23:59";

    this.getCatalogos();
    this.getParametros();
    this.getListaClientes();
  },

  mounted() {
    $("input[datatype='fecha']").datetimepicker();
    this.loading = false;
  },

  watch: {
    selected_product(newVal) {
      if (newVal != null && newVal !== "") {
        this.selectProduct(newVal);
        this.selected_product = null;
        this.$nextTick(() => {
          this.productSelectKey++;
        });
      }
    }
  },

  methods: {
    /* ===========================================================
       UTILIDADES
    ============================================================ */
    _toDecimal(val) {
      if (val === null || typeof val === "undefined") return 0;
      const s = String(val).replace(/\s+/g, "").replace(",", ".");
      const n = parseFloat(s);
      return isNaN(n) ? 0 : n;
    },

    _formatAsString(val) {
      const n = this._toDecimal(val);
      return Number.isInteger(n) ? n.toString() : n.toFixed(2);
    },

    /* ===========================================================
       VALIDACIONES: PRECIOS Y CANTIDADES
    ============================================================ */
    validateProducts() {
      let firstInvalid = null;

      for (let i = 0; i < this.selected_products.length; i++) {
        const p = this.selected_products[i];

        const precioTmp = this._toDecimal(p.temp_precio);
        const precioVal = this._toDecimal(p.precio);
        const cantVal = this._toDecimal(p.cantidad);

        p.invalidPrecio = !(precioTmp > 0 || precioVal > 0);
        p.invalidCantidad = !(cantVal >= 1);

        if (!firstInvalid) {
          if (p.invalidPrecio) firstInvalid = { type: "price", index: i };
          else if (p.invalidCantidad) firstInvalid = { type: "qty", index: i };
        }
      }

      if (firstInvalid) this.focusFirstInvalid(firstInvalid);

      return !firstInvalid;
    },

    focusFirstInvalid(obj) {
      this.$nextTick(() => {
        const id = obj.type === "price" ? `price-${obj.index}` : `qty-${obj.index}`;
        const el = document.getElementById(id);
        if (el) el.focus();
      });
    },

    /* ===========================================================
       CLIENTES
    ============================================================ */
    selectCliente(client) {
      const getSelected = () => {
        const id = client?.id ?? this.cliente;
        return this.clientesById?.[id] || client || null;
      };

      const hasVal = (v) =>
        v !== null && v !== undefined && v !== "" && v !== 0 && v !== "0";
      const toNum = (v) => {
        if (!hasVal(v)) return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      };

      this.disabled_metodo_pago = false;
      this.disabled_uso_cfdi = false;
      this.disabled_forma_pago = false;

      const sel = getSelected();
      if (!sel) return;

      this.cliente = sel.id;
      const selectedId = sel.id ?? this.cliente;
      const isEspecialCero = selectedId === "0" || selectedId === 0;

      if (isEspecialCero) {
        this.tipo_venta = 72;
        this.metodo_pago = 48;
        this.uso_cfdi = 22;
        this.forma_pago = 50;
        this.mostrar_periodo = true;

        this.disabled_metodo_pago = true;
        this.disabled_uso_cfdi = true;
        this.disabled_forma_pago = true;

        this.tercero_nit = "";
      } else {
        this.mostrar_periodo = false;

        this.tipo_venta = null;
        this.metodo_pago = null;
        this.uso_cfdi = null;
        this.forma_pago = null;

        this.tercero_nit = sel.nit ?? sel.identificacion ?? "";

        const fiscal = sel.fiscales ?? {};
        const metodoPagoNum = toNum(fiscal.metodo_pago);
        const usoCfdiNum = toNum(fiscal.uso_cfdi ?? fiscal.uso_cdfi);
        const formaPagoNum = toNum(fiscal.forma_pago);

        if (hasVal(metodoPagoNum)) {
          this.metodo_pago = metodoPagoNum;
          this.disabled_metodo_pago = true;
        }

        if (hasVal(usoCfdiNum)) {
          this.uso_cfdi = usoCfdiNum;
          this.disabled_uso_cfdi = true;
        }

        if (hasVal(formaPagoNum)) {
          this.forma_pago = formaPagoNum;
          this.disabled_forma_pago = true;
        }
      }

      // Cargamos productos del cliente seleccionado
      this.getListaProductos();
      this.selected_products = [];
      this.recalculo();
    },

    getParametros() {
      this.loading = true;
      this.facturadorService
        .getParametros(this.person)
        .then((data) => {
          this.fecha = GLOBAL.NOW_WITH_TZ(data.parametros.zona_horaria);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getListaClientes() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          const safeObj = (val) =>
            val && typeof val === "object" && !Array.isArray(val) ? val : {};

          this.lista_clientes = [];
          this.clientesById = {};

          for (const item of data) {
            const attrs = safeObj(item.atributos);
            const fisc = safeObj(attrs.fiscales);

            const cliente = {
              id: item._id,
              text: `${item.identificacion} - ${item.nombres}`,
              nit: item.identificacion,
              nombre: item.nombres,
              fiscales: {
                uso_cfdi: fisc.uso_cfdi ?? fisc.uso_cdfi ?? "",
                metodo_pago: fisc.metodo_pago ?? "",
                forma_pago: fisc.forma_pago ?? ""
              }
            };

            this.lista_clientes.push(cliente);
            this.clientesById[cliente.id] = cliente;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /* ===========================================================
       CATALOGOS
    ============================================================ */
    getCatalogos() {
      this.facturadorService.getCatalogos(this.person).then((json) => {
        this.lista_metodo_pago = [];
        this.lista_forma_pago = [];
        this.lista_uso_cfdi = [];
        this.lista_tipo_venta = [];
        this.lista_perioricidad = [];

        for (const i in json) {
          switch (json[i].tipo) {
            case GLOBAL.CATALOGO_MEXICO.METODO_PAGO:
              this.lista_metodo_pago.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.FORMA_PAGO:
              this.lista_forma_pago.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.USO_CFDI:
              this.lista_uso_cfdi.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.TIPO_VENTA:
              this.lista_tipo_venta.push(json[i]);
              break;
            case GLOBAL.CATALOGO_MEXICO.PERIORICIDAD:
              this.lista_perioricidad.push(json[i]);
              break;
          }
        }
      });
    },

    /* ===========================================================
       PRODUCTOS
    ============================================================ */
    getListaProductos() {
      const clienteSeleccionado = this.cliente;
      if (!clienteSeleccionado) {
        console.warn("No hay cliente seleccionado para cargar productos");
        this.lista_productos = [];
        return;
      }

      this.loading = true;

      const url1 = `${GLOBAL.API_GET_LISTA_PRODUCTOS_MEXICO}/${clienteSeleccionado}`;
      console.log("Cargando productos para cliente:", clienteSeleccionado, "URL:", url1);

      return axios
        .get(url1.trim(), {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Basic " + this.person.token,
            Environment: this.person.empresas
          }
        })
        .then((resp) => {
          const body = resp?.data || {};          // { success, size, data }
          const productos = Array.isArray(body.data) ? body.data : [];

          if (!Array.isArray(body.data)) {
            console.warn("Respuesta inesperada al cargar productos:", body);
          }

          this.lista_productos = productos.map((product) => ({
            id: product._id,
            text: `${product.plu} - ${product.descripcion}`,
            plu: product.plu,
            descripcion: product.descripcion,
            precio: this._toDecimal(product.precio_cliente),
            impuesto: !!product.impuesto,
            unidad_id: product.unidad_id,
            unidad_codigo: product.unidad_codigo,
            unidad_descripcion: product.unidad_descripcion
          }));

          console.log("Productos cargados:", this.lista_productos.length);
        })
        .catch((error) => {
          console.error("Error al cargar productos:", error);
          this.lista_productos = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },


    selectProduct(payload) {
      const selectedId = payload && payload.id ? payload.id : payload;
      const opt = this.lista_productos.find(
        (p) => String(p.id) === String(selectedId)
      );
      if (!opt) return;

      const existente = this.selected_products.some(
        (p) => String(p.id) === String(opt.id)
      );
      if (existente) {
        this.despacho_mensaje = "Este producto ya fue agregado.";
        this.selected_product = null;
        this.$nextTick(() => this.productSelectKey++);
        return;
      }

      const precio = this._toDecimal(opt.precio);
      const cantidad = 1;
      const subtotal = opt.impuesto
        ? precio * cantidad * 1.16
        : precio * cantidad;

      this.selected_products.push({
        id: opt.id,
        plu: opt.plu,
        descripcion: opt.descripcion,
        impuesto: opt.impuesto,
        unidad_id: opt.unidad_id,
        unidad_codigo: opt.unidad_codigo,
        unidad_descripcion: opt.unidad_descripcion,
        cantidad: 1,
        precio,
        temp_precio: this._formatAsString(precio),
        subtotal,
        invalidPrecio: false,
        invalidCantidad: false,
        descripcion_item: ""
      });

      this.recalculo();
      this.selected_product = null;
      this.$nextTick(() => this.productSelectKey++);
    },

    commitPrice(index) {
      const p = this.selected_products[index];
      const nuevoPrecio = this._toDecimal(p.temp_precio);

      p.invalidPrecio = !(nuevoPrecio > 0);

      p.precio = nuevoPrecio;
      const cant = this._toDecimal(p.cantidad) || 1;

      p.subtotal = p.impuesto ? nuevoPrecio * cant * 1.16 : nuevoPrecio * cant;
      p.temp_precio = this._formatAsString(nuevoPrecio);

      this.recalculo();
    },

    cancelPrice(index) {
      const p = this.selected_products[index];
      p.temp_precio = this._formatAsString(p.precio);
    },

    updateSubtotal(index) {
      const p = this.selected_products[index];

      let cantidad = this._toDecimal(p.cantidad);
      if (cantidad < 1 || isNaN(cantidad)) cantidad = 1;

      p.cantidad = cantidad;
      p.invalidCantidad = !(cantidad >= 1);

      const precio = this._toDecimal(p.precio);
      p.subtotal = p.impuesto ? precio * cantidad * 1.16 : precio * cantidad;

      this.recalculo();
    },

    removeProduct(index) {
      this.selected_products.splice(index, 1);
      this.recalculo();
    },

    recalculo() {
      this.total_facturar = 0;
      this.total_descuento = 0;
      this.total_subtotal = 0;
      this.total_cantidad = 0;

      for (const p of this.selected_products) {
        const precio = this._toDecimal(p.precio);
        const cant = this._toDecimal(p.cantidad) || 1;

        const subtotalLinea = p.impuesto ? precio * cant * 1.16 : precio * cant;
        const subtotalSinIVA = p.impuesto ? subtotalLinea / 1.16 : subtotalLinea;

        p.subtotal = subtotalLinea;

        this.total_facturar += subtotalLinea;
        this.total_subtotal += subtotalSinIVA;
        this.total_cantidad += cant;
      }
    },

    /* ===========================================================
       FACTURACIÓN
    ============================================================ */
    generarFactura() {
      this.boton_guardar_desabilitado = true;
      this.boton_enviar_desabilitado = true;
      this.boton_consultar_desabilitado = true;

      this.despacho_mensaje = "";
      let error = null;

      const isEmpty = (v) =>
        v === null || v === undefined || v === "" || v === 0;

      if (isEmpty(this.cliente)) error = "Seleccione un CLIENTE";
      if (isEmpty(this.uso_cfdi)) error = "Seleccione el USO CFDI";
      if (isEmpty(this.metodo_pago)) error = "Seleccione MÉTODO DE PAGO";
      if (isEmpty(this.forma_pago)) error = "Seleccione FORMA DE PAGO";
      if (isEmpty(this.tipo_venta)) error = "Seleccione TIPO DE VENTA";
      if (!this.selected_products.length)
        error = "Seleccione los productos a procesar";

      if (error) {
        this.despacho_mensaje = error;
        this.boton_guardar_desabilitado = false;
        return;
      }

      if (!this.validateProducts()) {
        this.despacho_mensaje =
          "Corrige los campos en rojo: precio debe ser mayor a 0 y cantidad al menos 1.";
        this.boton_guardar_desabilitado = false;
        return;
      }

      for (const p of this.selected_products) {
        p.precio = this._toDecimal(p.temp_precio);
        const cant = this._toDecimal(p.cantidad);
        p.subtotal = p.impuesto ? p.precio * cant * 1.16 : p.precio * cant;
        p.temp_precio = this._formatAsString(p.precio);
      }

      let venta_total = 0;
      let venta_subtotal = 0;
      let impuesto_total = 0;
      let descuento_total = 0;

      const detalles = [];

      for (const product of this.selected_products) {
        const precioUnit = this._toDecimal(product.precio);
        const cantidad = this._toDecimal(product.cantidad);

        const totalLinea = product.impuesto
          ? precioUnit * cantidad * 1.16
          : precioUnit * cantidad;

        const baseLinea = product.impuesto ? totalLinea / 1.16 : totalLinea;
        const ivaLinea = totalLinea - baseLinea;

        venta_total += totalLinea;
        venta_subtotal += baseLinea;
        impuesto_total += ivaLinea;

        detalles.push({
          uniqueid: product.id,
          producto_id: product.id,
          producto_plu: product.plu,
          producto_nombre: product.descripcion,
          producto_descripcion: product.descripcion_item || "",
          unidad_id: product.unidad_id,
          unidad_codigo: product.unidad_codigo,
          unidad_descripcion: product.unidad_descripcion,
          cantidad,
          precio: precioUnit,
          impuesto: product.impuesto ? 16 : 0,
          subtotal: baseLinea,
          iva: ivaLinea,
          total: totalLinea
        });
      }

      const nit =
        this.tercero_nit ||
        this.clientesById?.[this.cliente]?.nit ||
        "";

      if (!nit) {
        this.despacho_mensaje =
          "El cliente no tiene RFC/NIT configurado.";
        this.boton_guardar_desabilitado = false;
        return;
      }

      const movimiento = {
        documento_id: GLOBAL.DOCUMENTO.FACTURA_ELECTRONICA,
        fecha: this.fecha,
        persona_uniqueid: this.person.persona_id,
        tercero_uniqueid: this.cliente,
        tercero_nit: nit,
        fecha_creacion: this.fecha,
        costo_total: 0,
        venta_subtotal,
        impuesto_total,
        descuento_total,
        venta_total,
        estado: "P",
        atributos: {
          tipo_venta: this.tipo_venta,
          metodo_pago: this.metodo_pago,
          uso_cfdi: this.uso_cfdi,
          forma_pago: this.forma_pago,
          perioricidad: this.perioricidad,
          observaciones: this.observaciones
        },
        detalles
      };

      const request = {
        factura_manual: true,
        movimiento
      };

      this.mensaje_guardando = true;

      this.facturadorService
        .crearFacturaPOSMexico(this.person, request)
        .then((data) => {
          if (data?.status === 200) {
            this.despacho_mensaje = "¡Proceso realizado con éxito!";
            this.factura_prefijo = data.data.prefijo;
            this.factura_consecutivo = data.data.consecutivo;
            this.factura_uniqueid = data.data.uniqueid;
            this.factura_hasp = data.data.public_hasp;

            this.proceso_finalizado = true;

            this.boton_guardar_desabilitado = true;
            this.boton_enviar_desabilitado = false;
          } else {
            this.despacho_mensaje =
              "Proceso no fue realizado, reintente";
            this.boton_guardar_desabilitado = false;
          }
        })
        .catch(() => {
          this.despacho_mensaje =
            "Proceso no se realizó, contacte soporte";
          this.boton_guardar_desabilitado = false;
        })
        .finally(() => {
          this.mensaje_guardando = false;
        });
    },

    enviarFactura() {
      const request = { uniqueid: this.factura_uniqueid };
      this.mensaje_enviando = true;

      this.facturadorService
        .enviarFactura40Mexico(this.person, request)
        .then((data) => {
          if (data?.status === 200) {
            this.despacho_mensaje =
              "Factura enviada correctamente al SAT";

            this.resetDatos();
            this.consultaFactura();
          } else {
            this.despacho_mensaje =
              "No se pudo enviar, reintente.";
          }
        })
        .catch(() => {
          this.boton_guardar_desabilitado = true;
          this.boton_enviar_desabilitado = true;
          this.boton_consultar_desabilitado = false;
          this.despacho_mensaje =
            "Error al enviar. Reintente consultar.";
        })
        .finally(() => {
          this.mensaje_enviando = false;
        });
    },

    consultaFactura() {
      const request = { uniqueid: this.factura_uniqueid };
      this.mensaje_consultando = true;

      this.facturadorService
        .consultaFactura40Mexico(this.person, request)
        .then((data) => {
          if (data?.status === 200) {
            if (data.data.uuid_sat == null) {
              this.boton_guardar_desabilitado = true;
              this.boton_enviar_desabilitado = true;
              this.boton_consultar_desabilitado = false;

              this.despacho_mensaje =
                "REINTENTE PARA CONSULTAR TIMBRADO";
            } else {
              this.boton_guardar_desabilitado = true;
              this.boton_enviar_desabilitado = true;
              this.boton_consultar_desabilitado = true;

              this.despacho_mensaje =
                "SAT UUID: " + data.data.uuid_sat;

              this.proceso_finalizado = true;
            }

            this.factura_sello = data.data.sello;
          } else {
            this.despacho_mensaje =
              "Proceso no realizado, intente de nuevo";
          }
        })
        .finally(() => {
          this.mensaje_consultando = false;
        });
    },

    /* ===========================================================
       RESET
    ============================================================ */
    nuevaFactura() {
      this.resetDatos();
      this.cliente = null;
      this.tipo_venta = null;
      this.metodo_pago = null;
      this.uso_cfdi = null;
      this.forma_pago = null;

      this.selected_products = [];

      this.disabled_metodo_pago = false;
      this.disabled_uso_cfdi = false;
      this.disabled_forma_pago = false;

      this.boton_guardar_desabilitado = false;
      this.proceso_finalizado = false;

      this.total_cantidad = 0;
      this.total_subtotal = 0;
      this.total_descuento = 0;
      this.total_facturar = 0;
    },

    resetDatos() {
      this.factura_prefijo = null;
      this.factura_consecutivo = null;
      this.factura_enviada = true;

      this.cliente = "";
      this.tipo_venta = "";
      this.metodo_pago = "";
      this.uso_cfdi = "";
      this.forma_pago = "";
      this.observaciones = "";

      this.total_facturar = 0;
      this.selected_products = [];

      this.despacho_mensaje = "";
      this.mensaje_enviando = false;

      this.boton_guardar_desabilitado = true;
      this.boton_enviar_desabilitado = true;
      this.boton_consultar_desabilitado = true;
    }
  }
};
</script>

<style scoped>
/* ====== Layouts y utilidades ====== */
.layout {
  display: block;
}

.pad20 {
  padding: 20px;
}

.row {
  margin-top: 10px;
}

.label {
  font-weight: 600;
  margin-bottom: 6px;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

/* ====== Encabezado / área de factura ====== */
.area-facturas-box {
  background-color: rgb(255, 252, 243);
  border: 1px solid #929292;
  padding-left: 5px;
  border-radius: 6px;
  transition: background-color .20s ease-in, border-color .20s ease-in;
}

.area-facturas-hn {
  font-family: "Oswald", sans-serif;
  font-size: 24px;
  color: #dddddd;
  font-weight: bold;
}

.area-facturas-h1 {
  font-family: "Oswald", sans-serif;
  font-size: 24px;
  color: #c50000;
  font-weight: bold;
}

.area-facturas-h2 {
  font-family: "Oswald", sans-serif;
  font-size: 18px;
  color: #ca0000;
  margin-top: -3px;
  margin-bottom: 5px;
}

.area-facturas-texto {
  font-family: monospace;
  font-size: 16px;
  color: #333;
  margin: 8px 0 14px 0;
}

.area-facturas-label {
  font-family: "Oswald", sans-serif;
  font-size: 14px;
  color: #555;
}

.area-facturas-texto.text-right {
  text-align: right;
}

/* ====== Tabla de productos ====== */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 12px;
  background: #fff;
}

.table thead th {
  font-weight: 700;
  border-bottom: 2px solid #e5e7eb;
  padding: 10px 8px;
  font-size: 13px;
  background: #f9fafb;
}

.table tbody td {
  border-bottom: 1px solid #eef2f7;
  padding: 8px;
  vertical-align: middle;
  font-size: 13px;
}

/* ====== Inputs ====== */
.form-control {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 6px 10px;
  height: 34px;
  line-height: 20px;
  box-shadow: none;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.form-control:focus {
  outline: none;
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.15);
}

/* Resaltado de error (precio/cantidad inválida) */
.input-error {
  border: 2px solid #e11d48 !important;
  background-color: #fee2e2;
}

.input-error:focus {
  border-color: #be123c !important;
  box-shadow: 0 0 0 3px rgba(225, 29, 72, 0.15);
}

/* ====== Select2 (contenedor) ====== */
.product-selection .form-control {
  border: 1px solid #ccc;
}

.product-selection {
  margin-top: 20px;
}

/* ====== Resumen derecha ====== */
.summary-right {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.summary-table {
  width: 260px;
  border-collapse: collapse;
  background: #fff;
}

.summary-table td {
  padding: 8px 6px;
  font-size: 14px;
}

.summary-table tr td:first-child {
  text-align: left;
  color: #4b5563;
}

.summary-table tr td:last-child {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

/* ===== Tipografía para bloques “registro” (si los usas) ===== */
.area-facturas-registro-recibo {
  font-family: "Oswald", sans-serif;
  font-size: 15px !important;
  padding-left: 5px;
}

.area-facturas-registro-placa {
  font-family: "Oswald", sans-serif;
  font-size: 22px !important;
  padding-left: 5px;
  margin-top: -10px;
  margin-bottom: 5px;
  color: chocolate;
}

.area-facturas-registro-fecha {
  font-family: "Oswald", sans-serif;
  font-size: 14px !important;
  margin-right: 5px;
  color: dimgray;
}

.area-facturas-registro-desc {
  font-family: "Oswald", sans-serif;
  font-size: 14px !important;
  color: rgb(171, 156, 150);
  text-align: right;
  margin-bottom: 3px;
}

.area-facturas-registro-num {
  font-family: "Oswald", sans-serif;
  font-size: 18px !important;
  color: rgb(65, 65, 65);
  text-align: right;
}

/* ====== Bloques “facturador” (hover, encabezados) ====== */
.facturador-titulo {
  color: chocolate;
  font-weight: 700;
  font-size: 16px;
  border: 1px solid #ccc;
  margin-top: 30px;
  background-color: antiquewhite;
  text-align: center;
  padding: 5px 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  cursor: pointer;
}

.facturador-titulo:hover {
  background-color: #fff30f;
}

.facturador-filtros {
  padding: 10px;
  background-color: rgb(189, 189, 189);
}

/* ====== Rayado alternado opcional ====== */
.striped-container .row:nth-child(odd) {
  background-color: rgb(243, 243, 243);
}

/* ====== Botones ====== */
.btn {
  border-radius: 6px;
}

.btn-primary {
  border-color: #2563eb;
  background-color: #2563eb;
}

.btn-primary:disabled {
  opacity: 0.65;
}

.bg-green {
  background-color: #16a34a;
  color: #fff;
}

.bg-green:hover {
  background-color: #15803d;
}

/* ====== Mensajería / estados ====== */
.text-center img {
  display: inline-block;
  margin-bottom: 6px;
}

/* ===== TH de tabla de productos ===== */
.table-products thead th {
  background: linear-gradient(to bottom, #f7f7f7, #ededed);
  color: #374151;
  font-weight: 700;
  font-size: 13px;
  padding: 10px 8px;
  border-bottom: 2px solid #d1d5db;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* ====== Responsivo ====== */
@media (max-width: 992px) {
  .summary-right {
    justify-content: stretch;
  }

  .summary-table {
    width: 100%;
  }

  .table thead th,
  .table tbody td {
    font-size: 12px;
    padding: 8px 6px;
  }
}
</style>
